export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Checkbox.vue?vue&type=template&id=8d0a7c26&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/Checkbox.vue?vue&type=template&id=8d0a7c26&
// module id = 1105
// module chunks = 0